
import { NewsletterService } from '../newsletter/newsletter.service';
import { AnalyticsService } from './services/analytics.service';
import { registerComponents } from './register-components'

interface TbwServices {
  newsletterService: NewsletterService;
  analyticsService: AnalyticsService;
}

declare global {
  interface Window {
    tbwServices: TbwServices;
  }
}

const init = async () => {
  const newsletterService = new NewsletterService();
  const analyticsService = new AnalyticsService();

  window.tbwServices = {
    newsletterService,
    analyticsService
  };

  registerComponents()
  return true
}

init()